// extracted by mini-css-extract-plugin
module.exports = {"title":"Modals_title__YVbqV","icon":"Modals_icon__l6cv-"};